export const SHOW_UPGRADE_MODAL = "UI/UPGRADE_MODAL/SHOW";
export const HIDE_UPGRADE_MODAL = "UI/UPGRADE_MODAL/HIDE";
